import { lang } from '@umu/ukit-lang';

export const getDefaultState: IState = {
    lastName: '', // 姓
    firstName: '', // 名
    phone: '', // 手机
    email: '', // 邮箱
    enterpriseName: '', //  企业名称
    positionName: null, // 职位
    description: '', // 留言
    department: '',
    staffCount: null,
    areaCode: '',
    codePosition: '',
    showLastName: false,
    showFirstName: false,
    showPhoneMsg: false,
    showMailMsg: false,
    showEnterpriseName: false,
    showPositionName: false,
    receiveSubscribe: true,
};

export const jobOptionList = [
    lang('社長・役員'),
    lang('本部長・事業部長・部長'),
    lang('課長・マネージャー'),
    lang('係長・主任・リーダー'),
    lang('一般社員'),
].map((item) => ({
    label: item,
    id: item,
}));

export const amountOptionList = [
    '< 50',
    '50 - 99',
    '100 - 499',
    '500 - 999',
    '1000 - 4999',
    '5000 - 9999',
    '> 10000',
].map((item) => ({
    label: item,
    id: item,
}));
